import BigCheckbox from './big-checkbox-container'

export default BigCheckbox
